import React, { useRef } from "react";
import SummaryStatusBar from "../SummaryStatusBar/SummaryStatusBar";
import FinancialValueContainer from "../FinancialValueContainer/FinancialValueContainer";
import ExtractBar from "../ExtractBar/ExtractBar";
import AccordionTable from "../AccordionTable/AccordionTable";
import { observer } from "mobx-react";
import {
  downloadPDFFile,
  exportExcel,
  getAsOfDate,
  getCurrentDate,
  getPortfolioAssetsExcelData,
  getPortfolioAssetsReportHeader,
  getPortfolioAssetsReportName,
  getPrintDate,
  getReportDetails,
  isOffshoreTabDataFailed,
  isPortfolioAssetsDataPresent,
  //printDocument,
} from "../../utils/functions";

//import PdfTable from "../PdfTable/PdfTable";
import UserStore from "../../store/UserStore";
import {
  errorText,
  financialExcelClms,
  offshoreAssetClassSheetName,
  offshoreFamilyViewTabs,
  portfolioAssetClassesPdfTableColumns,
} from "../../utils/constants";
import { useState } from "react";
import { useEffect } from "react";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import NoDataFinancialAssets from "../FinancialAssetSummary/NoDataFinancialAssets";
import DropDownWithInfo from "./DropDownWithInfo";
import AssetSummaryError from "../FinancialAssetSummary/AssetSummaryError";

const ListItem = ({ isActive, className, onClick, tabsData }) => {
  return (
    <li
      className={isActive ? "is-active" : "portfolio_tabs_btn_animation"}
      onClick={onClick}
    >
      <button className={`port_tab_bton ${className}`}>
        <img
          className={isActive ? "selected_tab" : ""}
          src={
            isActive
              ? tabsData?.img?.selectedImg
              : tabsData?.img?.notSelectedImg
          }
          alt={tabsData.name}
        />
      </button>
    </li>
  );
};

const OffshoreAssetSummary = observer(
  ({
    isOffshore,
    title,
    summarytitle,
    dataPoint,
    noDataMessage,
    setCurrency = () => {},
    currency = { currency: "" },
  }) => {
    const [selectedTab, setSelectedTab] = useState(offshoreFamilyViewTabs[0]);
    const [excelPdfData, setExcelPdfData] = useState([]);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const allocationArray = UserStore[dataPoint]?.allocationSummary;

    const pdfTableId = "assetclasspdf";

    //const pdfTableRef = useRef();
    const tabApiRef = useRef(null);

    // const handlePdf = () => {
    //   printDocument(pdfTableId, {
    //     width: 650,
    //     height: 600,
    //     name: getPortfolioAssetsReportName(),
    //   });
    // };

    useEffect(() => {
      let excelData = [];
      const tabId = selectedTab.id;

      // tabId === 0 means Asset class wise view is selected and tabId === 1 means family view is selected
      // So depending upon this tab selection, appropriate file data is set for downloading
      if (tabId === 0) {
        excelData = UserStore.offshoreData.downloadFileData;
      } else {
        excelData = UserStore.offshoreData.downloadFamilyViewFileData;
      }

      setExcelPdfData(getPortfolioAssetsExcelData({ excelData }));
    }, [
      selectedTab,
      UserStore.offshoreData.downloadFileData,
      UserStore.offshoreData.downloadFamilyViewFileData,
    ]);

    return (
      <>
        <div className="financial_outside">
          {/* If the currency API call succeeds, fetch and display all related currency data.
    If it fails, show the error screen under the tab and stop further data fetching. */}

          {UserStore.offshoreApiStatus.getUsersCurrency !== "failed" ? (
            <div className="financial_inside_main">
              <div className="finance_head_wrapper">
                <h2 className="finance_head">{title}</h2>
                <div className="tooltip-wrapper">
                  <DropDownWithInfo
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                    list={{
                      list: UserStore.currencyData,
                      keyName: "currency",
                    }}
                    selectedItem={currency?.currency}
                    applyFilter={(item) => {
                      // Set currency to selected currency from drop down
                      setCurrency(item);
                      if (tabApiRef.current) {
                        tabApiRef.current.abort();
                      }

                      const tabRef = new AbortController();
                      tabApiRef.current = tabRef;

                      // Get all required data for the selected currency
                      UserStore.getOffshoreTabData({
                        currency: item.currency,
                        tabRef,
                      });
                    }}
                    popupMenuClass="currency_popup"
                  />
                </div>
              </div>
              {/* On currency change, show the loading screen. */}
              {UserStore.isOffshoreAssetDataLoading ? (
                <div
                  className="report_table_loader"
                  style={{ minHeight: "630px" }}
                >
                  <div className="report_loader_wrapper add_margin">
                    <img
                      style={{ marginBottom: "300px" }}
                      className="loading_gif"
                      src={loaderGIF}
                      alt="loading..."
                    />
                  </div>
                </div>
              ) : UserStore.offshoreApiStatus.getUsersPortfolioReturn !==
                "failed" ? (
                //  After API success, validate global portfolio data using
                //   `isPortfolioAssetsDataPresent` and display global data or No Data screen.

                isPortfolioAssetsDataPresent({
                  dataCheck: UserStore[dataPoint]?.clientPortfolioReturn,
                }) ? (
                  <div className="financial_data_container">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        alignItems: "end",
                      }}
                    >
                      <FinancialValueContainer dataPoint={dataPoint} />
                    </div>
                    {isOffshoreTabDataFailed({
                      apiList: UserStore.offshoreApiStatus,
                    }) ? (
                      //  If global data is valid but another API fails error screen
                      <AssetSummaryError
                        className={"error_screen_asset_class"}
                        alternateText={"No Financial Assets"}
                        message={errorText}
                      />
                    ) : UserStore[dataPoint]?.clientAssetClass?.length ? (
                      <>
                        {" "}
                        <div className="summary_outside family_view_tab">
                          <h2 className="title">
                            {selectedTab.id === 0 ? summarytitle : ""}{" "}
                          </h2>
                          <div className="tab_container">
                            <div className="tabs_part">
                              <div className="tabs ">
                                <ul>
                                  {offshoreFamilyViewTabs.map(
                                    (tabsData, index) =>
                                      UserStore.getData === "fam" ? (
                                        <ListItem
                                          key={tabsData.name}
                                          isActive={
                                            selectedTab.id === tabsData.id
                                          }
                                          className={""}
                                          onClick={() =>
                                            setSelectedTab(tabsData)
                                          }
                                          tabsData={tabsData}
                                        />
                                      ) : (
                                        <ListItem
                                          key={tabsData.name}
                                          isActive={
                                            selectedTab.id === tabsData.id
                                          }
                                          className={"notClickable"}
                                          onClick={() => {}}
                                          tabsData={tabsData}
                                        />
                                      ),
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                          {excelPdfData && (
                            <ExtractBar
                              extractExcel={() => {
                                const columns = financialExcelClms;
                                exportExcel({
                                  sheetname: getPortfolioAssetsReportHeader({
                                    currency: currency.currency,
                                  }),
                                  columns,
                                  data: excelPdfData,
                                  reportDetails: {
                                    ...getReportDetails(
                                      UserStore?.exportDetails,
                                      UserStore.userData,
                                      UserStore.getData === "fam",
                                    ),
                                    date: getPrintDate(
                                      getAsOfDate(
                                        UserStore[dataPoint]
                                          ?.clientPortfolioReturn?.as_of_date,
                                      ),
                                    ),
                                  },
                                  exportFrom: "portfolioPage1",
                                  excelName: `${getPortfolioAssetsReportName()} - ${getCurrentDate()}`,
                                  customSheetName: offshoreAssetClassSheetName,
                                });
                              }}
                              extractPdf={() => {
                                // handlePdf();
                                // return;

                                return downloadPDFFile({
                                  headerName: getPortfolioAssetsReportHeader({
                                    currency: currency.currency,
                                  }),
                                  fileId: pdfTableId,
                                  name: getPortfolioAssetsReportName(),

                                  columns: portfolioAssetClassesPdfTableColumns,
                                  data: excelPdfData || [],
                                });
                              }}
                              title={"Allocation Summary"}
                              isTitle={false}
                            />
                          )}
                        </div>
                        {
                          <>
                            {allocationArray && selectedTab.id === 0 && (
                              <SummaryStatusBar dataSeries={allocationArray} />
                            )}
                            <AccordionTable
                              page={"normal"}
                              tab={selectedTab.id}
                              isOffshore={isOffshore}
                              dataPoint={dataPoint}
                              currency={currency}
                            />
                          </>
                        }
                      </>
                    ) : (
                      // If global data is valid but asset/sub-asset class data is empty then display No data screen
                      <NoDataFinancialAssets
                        className={"allocationTableOnly"}
                        alternateText={"No Financial Assets"}
                        message={noDataMessage}
                      />
                    )}
                  </div>
                ) : (
                  <NoDataFinancialAssets
                    className={""}
                    alternateText={"No Financial Assets"}
                    message={noDataMessage}
                  />
                )
              ) : (
                // If global portfolio returns API fails then show error screen.
                <AssetSummaryError
                  className={"error_screen_asset_class"}
                  alternateText={"No global investment"}
                  message={errorText}
                />
              )}
            </div>
          ) : (
            <AssetSummaryError
              className={"error_screen_asset_class"}
              alternateText={"No global investment"}
              message={errorText}
            />
          )}

          {/* <PdfTable
            headerName={getPortfolioAssetsReportHeader({
              currency: currency.currency,
            })}
            id={pdfTableId}
            data={excelPdfData || []}
            columns={portfolioAssetClassesPdfTableColumns}
            ref={pdfTableRef}
          /> */}
        </div>
      </>
    );
  },
);

export default OffshoreAssetSummary;
